import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 10000 } }

  connect() {
    this.dismissTimer = setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    clearTimeout(this.dismissTimer)
  }

  dismiss() {
    this.element.classList.add("opacity-0", "translate-y-1")
    setTimeout(() => this.element.remove(), 220)
  }
}
